// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-component-css-CenterProgress__progress--A4IqL{display:flex;align-items:center;justify-content:center;height:360px}`, "",{"version":3,"sources":["webpack://./src/component/css/CenterProgress.scss"],"names":[],"mappings":"AAAA,mDACC,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,YAAA","sourcesContent":[".progress {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\theight: 360px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progress": `src-component-css-CenterProgress__progress--A4IqL`
};
export default ___CSS_LOADER_EXPORT___;
